import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeAiSignModalView = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("ai_sign_modal_view", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeAiSignModalView = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("ai_sign_modal_view", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null
    });
};
